import React, {PropTypes} from 'react';
import {BootstrapTable,TableHeaderColumn} from 'react-bootstrap-table';

class LeaveBalanceTable extends React.Component {

    constructor() {
      super();
    }
    componentDidMount()
    {

    }

    render() {
        return (
          <div className="col-md-12" >
            <BootstrapTable
              pagination
              containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
              headerStyle={{
                borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
                , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
              }}
              tableStyle={{marginBottom: '5%', borderStyle: 'solid'}}

              maxHeight={"500px"} exportCSV={true} data={this.props.data}>
              <TableHeaderColumn dataField="empId" filter={{type: 'TextFilter',placeHolder: 'Employee Id'}} isKey={true}>Employee Id</TableHeaderColumn>
              <TableHeaderColumn dataField="empName" filter={{type: 'TextFilter',placeHolder: 'Employee Name'}}>Employee Name </TableHeaderColumn>
              <TableHeaderColumn dataSort={true} dataField="leaveBalance">Leave Balance</TableHeaderColumn>
              </BootstrapTable>
          </div>
        );
    }
}

LeaveBalanceTable.propTypes = {};

export default LeaveBalanceTable;





/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveBalance/LeaveBalanceTable.js
 **/